import React from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { ACTIVITY_TYPE } from "../../common/Constants";

export const getMainPageTableConfig = ({
  onShowDetail,
  userAccess,
  pagination,
}) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const currentPage = pagination?.page || 1;
        const currentLimit = pagination?.limit || 5;
      
        return (
          (currentPage - 1) * currentLimit +
          tableMeta.rowIndex +
          1
        );
      },
      sort: false,
    },
  },
  {
    name: "poPartId",
    label: "Nomor Purchase Order",
    options: {
      sort: false,
    },
  },
  {
    name: "poDate",
    label: "Tanggal Purchase Order",
    options: {
      sort: false,
    },
  },
  {
    name: "poMonth",
    label: "Purchase Order Month",
    options: {
      sort: false,
    },
  },
  {
    name: "partCategoryName",
    label: "Kategori Part",
    options: {
      sort: false,
    },
  },
  {
    name: "quantityFix",
    label: "Quantity Fix",
    options: {
      sort: false,
    },
  },
  {
    name: "quantityTentative1",
    label: "Quantity Tentative 1",
    options: {
      sort: false,
    },
  },
  {
    name: "quantityTentative2",
    label: "Quantity Tentative 2",
    options: {
      sort: false,
    },
  },
  {
    name: "id",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex }) => {
        return (
          <FlexView style={{ gap: "15px", justifyContent: "center" }}>
            <SimpleButton
              id="btn_view"
              styles={{ width: "unset" }}
              category="action_button"
              icon={<i className="fa color-red fa-lg fa-eye" />}
              onClick={() => onShowDetail(rowIndex, ACTIVITY_TYPE.VIEW, val)}
            />
            <SimpleButton
              id="btn_edit"
              styles={{ width: "unset" }}
              category="action_button"
              disabled={!userAccess?.updateAccess}
              icon={
                <i
                  className={`fa fa-lg fa-pencil-alt ${
                    userAccess?.updateAccess ? "color-red" : "color-dark-grey"
                  }`}
                />
              }
              onClick={() => onShowDetail(rowIndex, ACTIVITY_TYPE.UPDATE, val)}
            />
            <SimpleButton
              id="btn_delete"
              styles={{ width: "unset" }}
              category="action_button"
              disabled={!userAccess?.deleteAccess}
              icon={
                <i
                  className={`fa fa-lg fa-trash ${
                    userAccess?.deleteAccess ? "color-red" : "color-dark-grey"
                  }`}
                />
              }
              onClick={() => onShowDetail(rowIndex, ACTIVITY_TYPE.DELETE, val)}
            />
          </FlexView>
        );
      },
    },
  },
];
